import React from 'react'
import Route from 'react-router-dom/Route'
import Switch from 'react-router-dom/Switch'
import asyncComponent from '@oldscope/utils/asyncComponent'
import { format, subWeeks } from 'date-fns'
import { get } from 'lodash'
import { ContextProvider } from '../../components/LegacyContext'
import { ContentfulProvider, ContentfulQuery } from '../../components/ContentfulDataProvider'
import cfClient from '../../ContentfulClient'
import { Page } from '../../App'
import GANav from './GANav'
import Home from './Home'

const Lodging = asyncComponent(() => import('./Lodging'))
const Contact = asyncComponent(() => import('./Contact'))
const Register = asyncComponent(() => import('./Register'))
const Location = asyncComponent(() => import('./Location'))
const PostRegistrationPayment = asyncComponent(() => import('./PostRegistrationPayment'))
const Admin = asyncComponent(() => import('./admin/Admin'))

export default ({ match }) => {
  const isAdmin = window.location.pathname.indexOf('/ga/admin') === 0

  return (
    <ContentfulProvider client={cfClient}>
      <ContentfulQuery
        query={{
          content_type: 'gaEventInfo',
          select: 'fields.facilityName,fields.locationName,fields.locationAddress,fields.locationGeo,fields.startDate,fields.endDate,fields.hostingChurch,fields.generalContactEmail,fields.paymentContactEmail',
          'fields.startDate[gte]': format(
            subWeeks(new Date(), isAdmin ? 5 : 1),
          ),
        }}
      >
        {items => (
          <ContextProvider
            name="gaEventInfo"
            context={get(items, '[0].fields')}
          >
            <GANav />
            <Switch>
              <Route path={match.url} exact component={Home} />
              <Route path={`${match.url}/home`} component={Home} />
              <Route path={`${match.url}/lodging`} component={Lodging} />
              <Route path={`${match.url}/location`} component={Location} />
              <Route path={`${match.url}/contact`} component={Contact} />
              <Route path={`${match.url}/register`} component={Register} />
              <Route path={`${match.url}/admin`} component={Admin} />
              <Route path={`${match.url}/post-registration-payment`} component={PostRegistrationPayment} />
              <Route
                path={`${match.url}/:slug`}
                component={props => {
                  props.match.params.slug = `ga/${props.match.params.slug}`
                  return (<Page {...props} />)
                }}
              />
            </Switch>
          </ContextProvider>
        )}
      </ContentfulQuery>
    </ContentfulProvider>
  )
}
